module.exports = __webpack_public_path__ + "static/2-f38952f5fcf54cd4349fe57051288bac.jpeg";